import { getCourseId } from "../../Utils/utils";
import { TaskManager } from "./TaskManager";


export function loadTaskManagement(){
    const courseId = getCourseId()
    new TaskManager(courseId);
}